import * as THREE from 'three'
import Experience from '../../Experience'
import face_vertex from '../../../shaders/ring/face/vertex.glsl'
import face_fragment from '../../../shaders/ring/face/fragment.glsl'
import pile_vertex from '../../../shaders/ring/pile/vertex.glsl'
import pile_fragment from '../../../shaders/ring/pile/fragment.glsl'
import CustomShaderMaterial from "three-custom-shader-material/vanilla";
import anim from '../../Utils/anim'

// PILE FAIT FACE AU JOUEUR PAR DEFAULT 
// FACE EST CACHE

export default class Ring {
    constructor(position = { x: 0, y: 0, z: 0 }, meshes, parentGroup, texture = null, win, id) {
        this.experience = new Experience()
        this.position = position
        this.meshes = meshes.clone()
        this.parent = parentGroup
        this.texture = texture
        this.win = win
        this.id = id
        this.isHovered = false
        this.isHidden = true
        this.raycaster = new THREE.Raycaster()

        // MATERIALS
        this.faceMaterial = new CustomShaderMaterial({
            baseMaterial: THREE.MeshPhysicalMaterial,
            metalness: 0.8,
            vertexShader: face_vertex,
            fragmentShader: face_fragment,
            transparent: true,
            side: THREE.DoubleSide,
            uniforms: {
                logo: new THREE.Uniform(this.texture),
                u_zoom: new THREE.Uniform(0.6),
                colorOne: new THREE.Uniform(new THREE.Color('#555555')),
                colorTwo: new THREE.Uniform(new THREE.Color('#ffffff')),
                u_win: new THREE.Uniform(this.win)
            }
        })
        this.pileMaterial = new CustomShaderMaterial({
            baseMaterial: THREE.MeshPhysicalMaterial,
            metalness: 0.8,
            roughness: 0.7,
            vertexShader: pile_vertex,
            fragmentShader: pile_fragment,
            transparent: true,
            side: THREE.DoubleSide,
            uniforms: {
                logo: new THREE.Uniform(this.texture),
                u_zoom: new THREE.Uniform(0.6),
                colorOne: new THREE.Uniform(new THREE.Color('#555555')),
                colorTwo: new THREE.Uniform(new THREE.Color('#ffffff')),
                u_win: new THREE.Uniform(this.win)
            }
        })



        this.init()
        // 
        this.face.material = this.faceMaterial
        this.pile.material = this.pileMaterial




    }
    setWin(value) {
        this.win = value
        this.faceMaterial.uniforms.u_win.value = value
        this.pileMaterial.uniforms.u_win.value = value
    }
    init() {
        this.meshes.traverse((el) => {
            el.name === 'Circle' ? this.circle = el : null
            el.name === 'shaderPlane1' ? this.pile = el : null
            el.name === 'shaderPlane2' ? this.face = el : null
            el.userData = { ringId: this.id };

        })
        this.meshes.position.set(this.position.x, this.position.y, this.position.z)
        this.parent.add(this.meshes)


    }
    show() {
        anim.to(this.meshes.rotation, { y: Math.PI, duration: 0.5, easing: 'power2.inout' })
        this.isHidden = false

        // tester le nombre de jetons retournés
        const testArray = this.experience.world.casino.rings.filter((ring) => {
            return !ring.isHidden
        })
        // si on en a retourné 3
        if (testArray.length === 3) {
            // win / loose / local reset
            const winArray = testArray.filter((r) => r.win)
            this.experience.world.casino.life -= 1

            console.log(this.experience.world.casino.life);

            if (winArray.length === 3 && this.experience.world.casino.life >= 0) {
                setTimeout(() => {
                    // ici animation de victoire
                    document.querySelector('.win').style.opacity = '1'
                }, 800)
            } else if (this.experience.world.casino.life <= 0) {
                setTimeout(() => {
                    // ici animation de défaite
                    document.querySelector('.loose').style.opacity = '1'
                }, 800)
            } else {

                setTimeout(() => {
                    this.experience.world.casino.localReset()

                }, 800)

            }


        }


    }
    hide() {
        anim.to(this.meshes.rotation, { y: 0, duration: 0.5, easing: 'power2.inout' })
        this.isHidden = true
    }



    update() {

        // this.meshes.rotation.set(0, (this.experience.time.elapsed * 0.001), 0)

        // raycaster
        this.raycaster.setFromCamera(this.experience.world.casino.mouse, this.experience.camera.instance)
        const intersects = this.raycaster.intersectObjects(this.meshes.children, false);


        this.isHovered = intersects.length ? true : false
        if (this.isHovered) {
            this.meshes.scale.x = THREE.MathUtils.lerp(this.meshes.scale.x, !this.isHidden ? 1.1 : 0.95, 0.08)
            this.meshes.scale.y = THREE.MathUtils.lerp(this.meshes.scale.y, !this.isHidden ? 1.1 : 0.95, 0.08)
            this.meshes.scale.z = THREE.MathUtils.lerp(this.meshes.scale.z, !this.isHidden ? 1.1 : 0.95, 0.08)

        } else {
            this.meshes.scale.x = THREE.MathUtils.lerp(this.meshes.scale.x, !this.isHidden ? 1.1 : 1, 0.08)
            this.meshes.scale.y = THREE.MathUtils.lerp(this.meshes.scale.y, !this.isHidden ? 1.1 : 1, 0.08)
            this.meshes.scale.z = THREE.MathUtils.lerp(this.meshes.scale.z, !this.isHidden ? 1.1 : 1, 0.08)
        }




    }
}